import { combineReducers } from "redux";
import sgbProductDetailsReducer from "./sgbProductDetials";
import sgbOrderDetailsReducer from "./sgbOrderDetails";
export default combineReducers({
    sgbProductDetailsReducer,
    sgbOrderDetailsReducer,
});
